// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import './element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'

// import _ from 'lodash'
// import VueSession from 'vue-session'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import { store } from './../state/index'
// element-ui
// // Include and set up Sails client
// import sailsWebsocketPlugin from './sailsWebsocketPlugin.js'
import UxConfig from './UxConfig.js'
// shortcuts
import shortcuts from 'vue-shortkey'
// input mask
import VueMask from 'v-mask'
// FormSchema
// eslint-disable-next-line no-unused-vars
// import { Components, GLOBAL as FormSchemaGlobal } from './FormSchema.esm.min.js'
// import FormSchemaElementUI from './components/FormSchemaElementUI.js'
// icons
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEnvelope, faLock, faUnlock, faPlus, faMinus, faEdit, faSave, faTimes, faTrash, faUnlink, faLink, faRetweet, faBars, faUpload, faHeadphonesAlt, faPhoneSlash, faHourglass, faVolumeUp, faVolumeOff, faBarcode,
  faDownload, faPencilAlt, faUndo, faPowerOff, faFilter, faVideo, faImage, faFolder, faFolderPlus, faFolderMinus, faPause, faCaretDown, faCaretRight, faInfoCircle, faUnlockAlt, faRulerHorizontal, faAddressCard,
  faFolderOpen, faBan, faCheckSquare, faSquare, faClock, faDesktop, faCopy, faPaste, faCut, faUsers, faUser, faTags, faBroadcastTower, faCode, faBug, faShare, faExclamationCircle, faTasks, faObjectUngroup,
  faFilm, faFileVideo, faSync, faCalendarAlt, faPalette, faArrowsAltH, faUniversity, faHdd, faHeartbeat, faFile, faFileArchive, faWifi, faCameraRetro, faWindowMaximize, faWindowMinimize, faIndustry, faCompress,
  faChessKing, faCaretSquareLeft, faCaretSquareRight, faCaretSquareDown, faThumbsUp, faCloudUploadAlt, faCloudDownloadAlt, faFileDownload, faCogs, faCog, faWrench, faTerminal, faClipboardList, faMagnifyingGlass,
  faChalkboardTeacher, faMapMarkedAlt, faLayerGroup, faLanguage, faHandPointLeft, faMedkit, faInfo, faChevronLeft, faChevronRight, faChevronDown, faList, faInfinity, faExpand, faSortAmountDown, faSortAlphaDown, faFolderTree,
  faPlay, faStop, faForward, faBackward, faCrop, faTint, faStopwatch, faExchangeAlt, faEye, faEyeSlash, faSpinner, faCheck, faTh, faThLarge, faRecycle, faHandPaper, faSignInAlt, faTextHeight, faUserEdit, faArrowDown, faIndent,
  faGlobe, faCertificate, faUserSecret, faHome, faArrowRight, faArrowLeft, faArrowsAlt, faPaintBrush, faHistory, faMagic, faNetworkWired, faSignOutAlt, faMoon, faCloud, faUserCog, faExpandArrowsAlt
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueSession from 'vue-session'
import sailsWebsocketPlugin from './sailsWebsocketPlugin.js'
import App from './App'
import router from './router'
import Messages from './messages'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
// FormSchemaGlobal.components = FormSchemaElementUI(Components)
// FormSchemaGlobal.Elements = new FormSchemaElementUI()

Vue.use(sailsWebsocketPlugin)

const options = {
  persist: true
}
Vue.use(VueSession, options)

Vue.use(shortcuts, { prevent: ['input', 'textarea'] })
Vue.use(VueMask)

library.add(
  faEnvelope, faLock, faUnlock, faPlus, faMinus, faEdit, faSave, faTimes, faTrash, faUnlink, faLink, faRetweet, faBars, faUpload, faHeadphonesAlt, faPhoneSlash, faHourglass, faVolumeUp, faVolumeOff, faBarcode,
  faDownload, faPencilAlt, faUndo, faPowerOff, faFilter, faVideo, faImage, faFolder, faFolderPlus, faFolderMinus, faPause, faCaretDown, faCaretRight, faInfoCircle, faUnlockAlt, faRulerHorizontal, faAddressCard,
  faFolderOpen, faBan, faCheckSquare, faSquare, faClock, faDesktop, faCopy, faPaste, faCut, faUsers, faUser, faTags, faBroadcastTower, faCode, faBug, faShare, faExclamationCircle, faTasks, faObjectUngroup,
  faFilm, faFileVideo, faSync, faCalendarAlt, faPalette, faArrowsAltH, faUniversity, faHdd, faHeartbeat, faFile, faFileArchive, faWifi, faCameraRetro, faWindowMaximize, faWindowMinimize, faIndustry, faCompress,
  faChessKing, faCaretSquareLeft, faCaretSquareRight, faCaretSquareDown, faThumbsUp, faCloudUploadAlt, faCloudDownloadAlt, faFileDownload, faCogs, faCog, faWrench, faTerminal, faClipboardList, faMagnifyingGlass,
  faChalkboardTeacher, faMapMarkedAlt, faLayerGroup, faLanguage, faHandPointLeft, faMedkit, faInfo, faChevronLeft, faChevronRight, faChevronDown, faList, faInfinity, faExpand, faSortAmountDown, faSortAlphaDown, faFolderTree,
  faPlay, faStop, faForward, faBackward, faCrop, faTint, faStopwatch, faExchangeAlt, faEye, faEyeSlash, faSpinner, faCheck, faTh, faThLarge, faRecycle, faHandPaper, faSignInAlt, faTextHeight, faUserEdit, faArrowDown, faIndent,
  faGlobe, faCertificate, faUserSecret, faHome, faArrowRight, faArrowLeft, faArrowsAlt, faPaintBrush, faHistory, faMagic, faNetworkWired, faSignOutAlt, faMoon, faCloud, faUserCog, faExpandArrowsAlt
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(UxConfig)
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(Vuelidate)
Vue.use(VueMomentJS, moment)
// Vue.use(sailsWebsocketPlugin)
// const options = {
//   persist: true
// }

// Vue.use(VueSession, options)

// Resolve to full URL just in case
const apiBaseUrl = new URL(
  process.env.VUE_API_BASE_URL, window.location.href).href.replace(/\/+$/g, '')

axios.defaults.baseURL = apiBaseUrl
axios.defaults.withCredentials = true
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

Vue.use(VueAxios, axios)
axios.interceptors.request.use(function (config) {
  config.headers.common['X-CSRF-Token'] = store.state.User.csrfToken
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (!error.config.disableResponseInterceptors) {
    store.dispatch('Error/setAxiosError', error.response)
  }
  return Promise.reject(error)
})
const i18n = new VueI18n({
  locale: 'en',
  messages: Messages,
  silentTranslationWarn: true
})

const LocaleMixin = {
  computed: {
    locale () {
      return 'en'
    }
  },
  watch: {
    locale () {
      this.$i18n.locale = this.locale
    }
  }
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      if (!store.state.User.user.id) {
        // Following requests throws an error if user is not logged in
        const resp = await Vue.axios.get('user/me', { disableResponseInterceptors: true })
        store.dispatch('User/setAuthProviders', resp.data.providers)
        await store.dispatch('User/loginSuccessful', resp.data)
      }
    } catch (err) {
      console.warn('Not authenticated', err)
      if (err.response && err.response.data.providers) {
        store.dispatch('User/setAuthProviders', err.response.data.providers)
      }

      return next({
        path: '/login'
      })
    }
  }

  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>',
  mixins: [LocaleMixin]
})

Vue.mixin({
  methods: {
    uxParam (param) {
      return Vue.$uxConf[param]
    },
    assembleLocalPlayListName: function (devicename, screenname, strict) {
      if (strict) return devicename + ' ' + screenname
      return 'Local playlist ' + devicename + ' ' + screenname
    },
    resolveItemToSave: function (whatToSave, data) {
      let path = whatToSave.split('.')
      let savedPath = JSON.parse(JSON.stringify(path))
      let obj = JSON.parse(JSON.stringify(data))
      path.shift()
      while (path.length > 0) {
        obj = obj[path[0]]
        path.shift()
      }
      return { endpoint: savedPath[1], column: savedPath[2], value: obj, id: data[savedPath[1]]['id'] }
    },
    /**
     * Return Base URL for API with optional url path
     * @param path {string | undefined}
     * @returns {string}
     */
    apiUrl: function (path) {
      path = path || ''
      return path !== ''
        ? apiBaseUrl + '/' + path
        : apiBaseUrl
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js